import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TrackingService } from '../../tracking/tracking.service';
import AppError from '../../model/app-error';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  @Input() header: string | null = null;
  @Input() message: string | null = null;
  @Input() appError: AppError | null = null;
  @Input() showTryAgain = false;
  @Output() tryAgain = new EventEmitter<void>();

  constructor(private trackingService: TrackingService) {}

  get messageToShow(): string {
    if (this.appError) {
      return this.appError.errorMessages?.join(', ') || this.appError.message || this.message || 'common.error.message';
    }

    return this.message || 'common.error.message';
  }

  get errorCodes(): string | null {
    if (this.appError) {
      return this.appError.errorCodes?.join(', ') || null;
    }

    return null;
  }

  ngOnInit(): void {
    this.trackingService.pageError({
      type: this.appError?.type || 'UNKNOWN',
      code: this.appError?.errorCodes?.join(', ') || 'UNKNOWN',
      message: this.appError?.message || this.message || 'COMMON_MESSAGE',
    });
  }
}
